import api from '../services/api';

// ————————————————————————————————————————————————
// API - Objetivos Estratégicos
// ————————————————————————————————————————————————

export async function listObjectives(tipo) {
  // O axios já usa a baseURL '/api' definida no services/api.js
  const response = await api.get('/strategic-objectives', {
    params: { tipo } // O axios monta ?tipo=... automaticamente
  });
  
  // O backend retorna { data: [...] }, então pegamos response.data.data
  // Se vier vazio, garantimos um array vazio []
  return response.data.data || [];
}

export async function createObjective(payload) {
  const response = await api.post('/strategic-objectives', payload);
  return response.data.data;
}

export async function updateObjective(id, payload) {
  const response = await api.put(`/strategic-objectives/${id}`, payload);
  return response.data.data;
}

export async function deleteObjective(id) {
  await api.delete(`/strategic-objectives/${id}`);
  return true;
}

// ————————————————————————————————————————————————
// API - Direcionamentos Estratégicos
// ————————————————————————————————————————————————

export async function getDirectionForType(tipo) {
  try {
    const response = await api.get(`/strategic-directions/${tipo}`);
    
    // O controller de direção retorna o objeto direto (não dentro de 'data')
    return response.data || { text: '' };
  } catch (error) {
    // Se for 404, retorna vazio em vez de estourar erro
    if (error.response && error.response.status === 404) {
      return { text: '' };
    }
    throw error;
  }
}

export async function saveDirectionForType(tipo, text) {
  const response = await api.put(`/strategic-directions/${tipo}`, { text });
  
  // O controller retorna o objeto salvo direto
  return response.data;
}